import { generatePath, useNavigate } from 'react-router';
import { PerformanceBadge } from '@tempmee/react';
import { OfficeDashboardTile } from '@tempmee/react-blocks';
import { useEligibleBidNomination } from '~/domain/BestInDental';
import { routes } from '~/routes';

/**
 * Dashboard "Best in Dental" quick-apply tile (GOTU-6482). Sits alongside the
 * shift status tiles and renders only while the office has an apply-eligible
 * BID nomination — a `nominee` membership whose cycle is still inside its
 * application window. Applying (status → `applicant`) or the window closing
 * clears `applyEligible`, so the tile disappears on the next history refetch.
 *
 * Rendered as the graphic style of the DS `OfficeDashboardTile`, so it matches
 * the shift tiles beside it. No analytics event is fired — BID client tracking
 * is intentionally out of scope.
 */
export const BidNominationCard = () => {
  const navigate = useNavigate();
  const { eligibleItem } = useEligibleBidNomination();

  if (!eligibleItem) {
    return null;
  }

  const handleClick = () => {
    navigate(generatePath(routes.bestInDentalApplication, { cycleId: eligibleItem.cycleId }));
  };

  return (
    <OfficeDashboardTile
      title="Best in Dental"
      description="Apply now"
      accent="cta"
      graphic={<PerformanceBadge variant="best-in-dental" size="medium" aria-hidden />}
      onClick={handleClick}
      className="flex-1"
      data-cy="bid-nomination-card"
    />
  );
};
